import { r as registerInstance, f as createEvent, h, e as Host, g as getElement } from './index-6c727dca.js';
import './component-errors-b6f1109b.js';
import { k as klassList } from './utils-c16d9285.js';

const epiLinkCss = ".epi-link__item{--fontColor:var(--brandPrimary);--fontColor_hover:var(--brandPrimaryLight);--fontColor_active:var(--brandPrimaryDark);cursor:pointer;font-size:clamp(1px, 1.6rem, 16px);color:var(--fontColor);text-decoration:underline;line-height:1.5}.epi-link__item:link,.epi-link__item:visited{color:var(--fontColor)}.epi-link__item:hover,.epi-link__item:focus{color:var(--fontColor_hover)}.epi-link__item:active{color:var(--fontColor_active)}.epi-link__item.m--bold{font-weight:600}.epi-link__item.m--small{font-size:clamp(1px, 1.4rem, 14px)}.epi-link__item.m--primary{--fontColor:var(--brandPrimary);--fontColor_hover:var(--brandPrimaryLight);--fontColor_active:var(--brandPrimaryDark)}.epi-link__item.m--accent{--fontColor:var(--brandAccent);--fontColor_hover:var(--brandAccentLight);--fontColor_active:var(--brandAccentDark)}.epi-link__item.m--secondary{--fontColor:var(--brandSecondary);--fontColor_hover:var(--brandSecondaryLight);--fontColor_active:var(--brandSecondaryDark)}.epi-link__item.m--warn{--fontColor:var(--brandWarn);--fontColor_hover:var(--brandWarnLight);--fontColor_active:var(--brandWarnDark)}.epi-link[disabled]{pointer-events:none;color:var(--black_s40)}.epi-link[disabled] .epi-link__item{color:inherit}";

const EpiLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.clicked = createEvent(this, "epi-link_clicked", 7);
    this.klassName = `epi-link`;
    /** The size of the link, when null it will be a standard sized link */
    this.size = null;
    /** The color of the link */
    this.color = `secondary`;
    /** Whether or not the link should be disabled */
    this.disabled = false;
    /** Whether or not the link should be bolded */
    this.bold = false;
    /**
     * Prompts the user to save the linked URL instead of navigating to it
     * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a
     */
    this.download = null;
    /** Where to display the linked URL */
    this.target = `self`;
  }
  handleClick(ev) {
    this.clicked.emit(ev);
  }
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender() { }
  // componentDidRender () { }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  /**
   * The render() function should always be the last one in the class
  */
  render() {
    return (h(Host, { class: this.klassName }, h("a", { class: klassList(`${this.klassName}__item`, this.bold && `m--bold`, this.size && `m--small`, `m--${this.color}`), ref: el => this.linkEl = el, href: this.to, hreflang: this.hreflang, target: `_${this.target}`, download: this.download, rel: this.rel, "aria-label": this.arialabel, "aria-labelledby": this.arialabelledby, onClick: ev => this.handleClick(ev) }, h("slot", null))));
  }
  get el() { return getElement(this); }
};
EpiLink.style = epiLinkCss;

export { EpiLink as epi_link };
